// removed by extract-text-webpack-plugin
module.exports = {"exitTimeout":"1000ms"};


//////////////////
// WEBPACK FOOTER
// ./src/views/Home/base/Loader.scss
// module id = 123
// module chunks = 0